module.exports = "/static/Images/es/survey_yes.png";